import { Injectable, inject } from "@angular/core";
import { DashboardsService } from "../dashboards-service/dashboards.service";
import { FirmsService } from "../firms-service/firms.service";
import { AuthService } from "../auth/auth.service";
import { UserDashboardSettingsService } from "../user-dashboard-settings-service/user-dashboard-settings.service";
import { Router } from "@angular/router";
import { IDashboardModel } from "../../views-interfaces/dashboard-model.interface";
import { type TUserDashboardSettingsModels } from "@app/views-interfaces/user-dashboard-settings.interface";

@Injectable({
    providedIn: "root",
})
export class ApplicationsService {
    private router = inject(Router);
    private readonly dashboardsService = inject(DashboardsService);
    private readonly firmsService = inject(FirmsService);
    private readonly authService = inject(AuthService);
    private readonly userDashboardSettings = inject(UserDashboardSettingsService);

    private initialized = false;
    private accessibleDashboards: IDashboardModel[] = [];
    private accessibleApplications = [];

    async getAccessibleApplications() {
        if (!this.initialized) {
            await this.initialize();
        }
        return this.accessibleApplications;
    }

    async getAccessibleDashboards() {
        if (!this.initialized) {
            await this.initialize();
        }
        return this.accessibleDashboards;
    }

    private async initialize() {
        const dashboards = await this.dashboardsService.getDashboardsList();
        const firm = await this.firmsService.getFirmById(this.authService.currentUser.firm_id);

        const userUds: TUserDashboardSettingsModels =
            (await this.userDashboardSettings.getUserDashboardSettingsForMe(this.authService.currentUser.sub)) ?? [];
        dashboards.forEach((dashboard) => {
            const application = firm.Applications.find((x) => x.Value === dashboard.Id);
            if (application) {
                const userDashboardUds = userUds.find((it) => it.DashboardId === dashboard.Id);
                if (!userDashboardUds || userDashboardUds.Active) {
                    if (!this.accessibleDashboards.find((it) => it.Id === dashboard.Id)) {
                        this.accessibleDashboards.push(dashboard);
                    }
                    let accessibleApplication = this.accessibleApplications.find((x) => x.Key === application.Key);
                    if (!accessibleApplication) {
                        accessibleApplication = { Key: application.Key, Value: [], Expanded: false };
                        this.accessibleApplications.push(accessibleApplication);
                    }
                    if (!accessibleApplication.Value.find((it) => it.Id === dashboard.Id)) {
                        accessibleApplication.Value.push(dashboard);
                    }
                }
            }
        });

        if (this.accessibleDashboards.length > 0) {
            this.accessibleDashboards.sort((a, b) => {
                if (a.CreationDate < b.CreationDate) {
                    return -1;
                } else if (a.CreationDate > b.CreationDate) {
                    return 1;
                } else {
                    return 0;
                }
            });
        } else {
            this.router.navigate(["/accessunauthorized"]);
        }
        if (this.accessibleApplications.length > 1) {
            this.accessibleApplications.sort((a, b) => {
                if (a.Key < b.Key) {
                    return -1;
                } else if (a.Key > b.Key) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }
        this.accessibleApplications.forEach((x) => {
            if (x.length > 1) {
                x.sort((a, b) => {
                    if (a.Value.CreationDate < b.Value.CreationDate) {
                        return -1;
                    } else if (a.Value.CreationDate > b.Value.CreationDate) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
            }
        });
        this.initialized = true;
    }
}
